import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from 'app/services';
import { Console } from 'console';

@Component({
  selector: 'app-redirect',
  template: '<p>Redirecting... Please wait.</p>',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const { url: targetUrl, src, ro, ...otherParams } = params;

      if(targetUrl || ro) {
        const event =  `Redirected to Google review ${ src ? `through ${src}`: ''}`;
        
        if (ro) {
            this.helperService.postGainsightPXEvent(event, { 
                ro: ro,
            });
        }
        
        if (targetUrl) {
            // Append all other params to targetUrl
            let finalUrl = targetUrl;
            const urlHasParams = targetUrl.includes('?');
            const paramEntries = Object.entries(otherParams);
            
            if (paramEntries.length > 0) {
                const queryString = paramEntries
                    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
                    .join('&');
                    
                finalUrl += urlHasParams ? `&${queryString}` : `?${queryString}`;
            }
            
            setTimeout(() => {
                window.location.href = finalUrl;
            }, 200);
        }
      } else {
        this.router.navigate(['/']);
        return;
      }
    });
  }
}
